<template>
  <div>
    <div class="order-main">
      <!--<div style="font-size: small;margin: 10px">{{ plateformordertype }}</div>
      <van-divider dashed style="color: #4d84e2;margin: 3px;"></van-divider>-->
      <div class="order-first-div">
        <div style="margin: 10px;">
          <van-icon name="info"/>
          <span>{{ plateformordertype }}</span>
        </div>
      </div>
      <van-divider dashed style="color: #4d84e2;margin: 3px;"></van-divider>
      <div class="order-first-div" style="background-color: white">
        <div>
          <span style="color: #333333;margin-left: 10px;line-height: 26px;">目标店铺</span>
        </div>
        <div>
          <span style="color: orangered;line-height: 26px;">{{ taskCommon.shopName }}</span>
        </div>
      </div>
      <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <div class="order-first-div" style="background-color: white">
        <div>
          <span style="color: #333333;margin-left: 10px;line-height: 26px;">目标商品</span>
        </div>
      </div>
      <div v-for="(cardataItem, index) in cardData.taskOrderDetailGoodsVos" :key="index">
      <van-card
          :thumb="cardataItem.thumbUrl">
        <template #title>
          <div style="width: 100%;word-wrap: break-word;">{{cardataItem.mainKey}}</div>
        </template>
        <template #tags>
          <div class="end-box">
            <div class="leftArea" style="font-size: small">
              <div v-if="cardataItem.isMainGood">搜索展示价格：<span style="color: #4d84e2">{{ cardataItem.showPrice }}</span> 元</div>
              <div v-if="cardataItem.isMainGood" style="margin-top: 2px;">当前销量：<span style="color: #4d84e2">{{ cardataItem.getGoodsPersons==null?0:cardataItem.getGoodsPersons }}</span> 件
              </div>
              <div v-if="!cardataItem.isMainGood">
                <div>规格: {{cardataItem.goodRule }}</div>
              </div>
              <div style="margin-top: 3px;" v-show="isNotBrowerOrder">商品单价：<span style="color: red">{{ cardataItem.buyPrice }}</span>元</div>
              <div style="margin-top: 3px;">购买数量：<span style="color: red">{{ cardataItem.buyNumbers }}</span>件</div>
              <div v-if="cardataItem.isMainGood" style="color: red">主商品</div>
            </div>
          </div>
        </template>
      </van-card>
      </div>
      <div class="order-first-div" style="background-color: white">
        <div style="color: orangered;line-height: 26px;margin-left: 10px">
          {{ cardData.orderStatus }}
        </div>
        <div>
        <span style="color: orangered;line-height: 26px;">
          <hour-second-count :remainTime="getTime" @countDowmEnd="countDowmEnd"></hour-second-count>
        </span>
        </div>
      </div>
      <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <div class="order-first-div" style="background-color: gray">
        <div style="margin: 10px;">
          <van-icon name="star"/>
          <span>任务要点</span>
        </div>
      </div>
      <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <div class="order-first-div" style="background-color: white">
        <div style="color: orangered;line-height: 26px;margin-left: 10px">
          <span>禁止使用淘宝客，返利网等方式下单，否则一律永久封号并冻结资金！禁止乱添加关键词</span>
        </div>
      </div>
      <div class="step-body">
        <van-list>
          <van-cell title="订单编号：" :value="taskCommon.orderNum"></van-cell>
          <van-cell title="任务类型：" :value="taskCommon.taskType"></van-cell>
          <div v-if="isNotDouyinTaskType">
          <van-cell>
            <template #title>
              {{taskCommon.taskType == '手机淘宝淘口令'?'淘口令：':'搜索关键字：'}}
            </template>
            <template #default>
              <div>{{ taskCommon.searchKeyword }}</div>
              <div v-show="taskCommon.taskType == '手机淘宝淘口令'">
              <van-button type="info" size="mini"
                          v-clipboard:copy="taskCommon.searchKeyword"
                          v-clipboard:success="onCopy"
                          v-clipboard:error="onError">点击复制
              </van-button>
              </div>
            </template>
          </van-cell>
          <van-cell title="备用关键字：" :value="taskCommon.backKeyword"></van-cell>
          <van-cell title="搜索类型：" :value="taskCommon.searchType"></van-cell>
          <van-cell title="商品所在地：" :value="taskCommon.goodsLocation"></van-cell>
          <van-cell title="价格区间：" :value="taskCommon.goodsPriceRange"></van-cell>
          </div>
          <div v-else>
            <div v-if="taskCommon.douyinAccount">
            <van-cell  title="抖音号：">
              <template #default>
                <div>{{ taskCommon.douyinAccount }}</div>
                <van-button type="info" size="mini"
                            v-clipboard:copy="taskCommon.douyinAccount"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError">点击复制
                </van-button>
              </template>
            </van-cell>
            <div style="text-align: center" v-show="taskCommon.douyinImgUrl != null">
              <div style="font-size: smaller;margin-left: 4%;text-align: initial;">抖音二维码:</div>
              <van-image style="margin: 5%;"
                         @click="perviewImage(taskCommon.douyinImgUrl)"
                         :src="taskCommon.douyinImgUrl"></van-image>
              <van-button @click="savePicture(taskCommon.douyinImgUrl)" style="margin-bottom: 2%;">点击下载</van-button>
              <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
            </div>
            </div>
            <div v-else>
              <van-cell  title="抖音关键字：">
                <template #default>
                  <div>{{ taskCommon.douyinKeyword }}</div>
                  <van-button type="info" size="mini"
                              v-clipboard:copy="taskCommon.douyinKeyword"
                              v-clipboard:success="onCopy"
                              v-clipboard:error="onError">点击复制
                  </van-button>
                </template>
              </van-cell>
            </div>
          </div>
          <van-cell v-for="item in filterKeys(taskCommon.taskLimits)" :key="item">
            <template #default>
              <span style="color: red">{{ item }}</span>
            </template>
          </van-cell>
        </van-list>
        <div style="text-align: center" v-show="isShowQrcodeImg">
        <div style="font-size: smaller;margin-left: 4%;text-align: initial;">二维码任务:</div>
        <van-image style="margin: 5%;"
            @click="perviewImage(taskCommon.qrcodeTaskImgUrl)"
            :src="taskCommon.qrcodeTaskImgUrl"></van-image>
        <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
        </div>
        <div style="position: relative;" v-if="isShowBusinesses">
          <van-cell v-show="isShowBusinessAttarch(taskCommon.remarksContent)" title="商家备注内容：" :value="taskCommon.remarksContent"></van-cell>
          <div v-show="isShowBusinessAttarch(taskCommon.firstImageUrl)" style="font-size: smaller;margin-left: 4%;text-align: initial;">图1:
            <br>
            <div style="width: 100%;text-align: center">
          <van-image style="margin: 5%;"
                     width="220"
                     height="220"
                     @click="perviewImage(taskCommon.firstImageUrl)"
                     :src="taskCommon.firstImageUrl"></van-image>
            </div>
            <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
          </div>
          <div v-show="isShowBusinessAttarch(taskCommon.secondImageUrl)" style="font-size: smaller;margin-left: 4%;text-align: initial;">图2:
            <br>
            <div style="width: 100%;text-align: center">
          <van-image style="margin: 5%;"
                     width="220"
                     height="220"
                     @click="perviewImage(taskCommon.secondImageUrl)"
                     :src="taskCommon.secondImageUrl"></van-image>
            </div>
            <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
          </div>
          <div v-show="isShowBusinessAttarch(taskCommon.thirdImageUrl)" style="font-size: smaller;margin-left: 4%;text-align: initial;">图3:
            <br>
            <div style="width: 100%;text-align: center">
          <van-image style="margin: 5%;"
                     width="220"
                     height="220"
                     @click="perviewImage(taskCommon.thirdImageUrl)"
                     :src="taskCommon.thirdImageUrl"></van-image>
            </div>
            <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
          </div>
        </div>
      </div>
      <div class="order-first-div" style="background-color: gray">
        <div style="margin: 10px;">
          <van-icon name="star"/>
          <span>注意事项</span>
        </div>
      </div>
      <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <div class="order-first-div" style="background-color: white">
        <div style="color:black;line-height: 33px;margin-left: 10px">
        <span>与商家聊天过程中切记不要出现 "任务， 做单， 种菜" 等词汇，
          按照正常购物流程和语气进行操作。</span>
        </div>
      </div>
      <van-list class="step-body">
        <van-cell>
          <template #title>
            <span style="color: red;" v-if="taskCommon.taskSerNeedUpimgs==null">1: 商家全程不需要截图</span>
            <span style="color: red;" v-else>1: 商家部分步骤需要截图，请参考任务要点的要求</span>
          </template>
        </van-cell>
        <van-cell>
          <template #title>
            <span style="color: red;">2: 但是必须一样按照全程操作， 平台会随机抽查，查到没有按照流程的封号处理。</span>
          </template>
        </van-cell>
      </van-list>
      <div class="order-first-div" style="background-color: gray">
        <div style="margin: 10px;">
          <van-icon name="star"/>
          <span>任务步骤</span>
        </div>
      </div>
      <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <div v-if="isNotDouyinTaskType">
      <div class="order-first-div" style="background-color: white">
        <div style="color: #5995fd;line-height: 44px;margin-left: 10px;">
          <span>第一步：目标商品 货比多家</span>
        </div>
      </div>
      <van-list class="step-body">
        <van-cell>
          <template #title>
            <span>1, 请确认使用的账户<span
                style="color: red;background-color: cornflowerblue;margin: 2%;width: 2rem;">{{ taskCommon.accountName }}</span>账号登录</span>
          </template>
        </van-cell>
        <van-cell>
          <template #title>
            <span>2, 点击搜索框输入指定的关键词</span>
          </template>
        </van-cell>
        <van-cell>
          <template #title>
            <span>3, 按要求设置筛选价格区间，所在地，类目等搜索条件缩小查询范围</span>
          </template>
        </van-cell>
        <van-cell>
          <template #title>
            <span>4, 任意点开多个非目标商品， 慢慢浏览至底部</span>
          </template>
        </van-cell>
        <van-cell>
          <template #title>
            <span>5, 找到目标商品图， 填写目标商品店铺验证。</span>
          </template>
        </van-cell>
      </van-list>
      <div class="order-first-div" style="background-color: white">
        <div style="color: orangered;line-height: 26px;margin-left: 10px">
          <span>填写目标商品店铺名称验证(提示：{{ taskCommon.shopName }})</span>
        </div>
      </div>
      </div>
      <div v-else>
        <div class="order-first-div" style="background-color: white">
          <div style="color: #5995fd;line-height: 44px;margin-left: 10px;">
            <span>第一步：找到目标商品</span>
          </div>
        </div>
        <van-list class="step-body">
          <van-cell>
            <template #title>
            <span>1, 请确认使用的账户<span
                style="color: red;background-color: cornflowerblue;margin: 2%;width: 2rem;">{{ taskCommon.accountName }}</span>账号登录抖音APP</span>
            </template>
          </van-cell>
          <van-cell>
            <template #title>
              <span>2, 保存"任务要点"中的抖音/商品二维码或复制抖音号，打开抖音app</span>
            </template>
          </van-cell>
          <van-cell>
            <template #title>
              <span>3, 从抖音app点搜索，打开扫一扫，在相册找到下载好的抖音/商品二维码；或者输入抖音号找到商品和(店铺)，关注抖音号（店铺）</span>
            </template>
          </van-cell>
          <van-cell>
            <template #title>
              <span>4, 跳到指定的视频，观看视频内容；</span>
            </template>
          </van-cell>
          <van-cell>
            <template #title>
              <span>5, 找到视频内的商品链接，(黄色购物车标记)， 点击收藏并点击"去购买"按钮。</span>
            </template>
          </van-cell>
          <van-cell>
            <template #title>
              <span>6, 跳转到抖音小店或者外部电商平台。按要求下单付款。</span>
            </template>
          </van-cell>
        </van-list>
        <div class="order-first-div" style="background-color: white">
          <div style="color: orangered;line-height: 26px;margin-left: 10px">
            <div>如果该二维码为抖音小店的商品二维码，扫码进入商品直接下单付款。</div>
            <span>填写目标抖音店铺名称验证(提示：{{ taskCommon.shopName }})</span>
          </div>
        </div>
      </div>
      <!--如果店铺已经审核通过， 则不需要验证了， 禁止输入-->
      <van-field v-model="shopName" placeholder="请输入店铺名" />
      <van-button type="info" size="normal" disabled v-if="b2cOperationTaskResult.isShopVerfiy">店铺已经验证通过</van-button>
      <van-button type="info" size="normal" @click="checkShopName" v-else>点击查看店铺名是否正确</van-button>
      <div class="order-first-div" style="background-color: white">
        <div style="color: orangered;margin-left: 10px">
          <span>由于部分抖音名/店铺名称相似，请仔细核对，确保下单的抖音名/店铺名称和要求的完全一致才能操作。</span>
          <div>排错店铺需要自行承担损失</div>
          <div>旗舰店≠专卖点≠专营店≠xx店</div>
        </div>
      </div>
      <div v-show="isShowQuesting">
      <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <div style="line-height: 26px;margin-left: 10px">提示:{{getQuestiongStr}}</div>
      <van-field v-model="answerString" placeholder="请输入详情词"/>
      <van-button style="width: 100%;" type="info" size="normal" @click="checkAnswer">{{ isCheckAnswer?"已校验":"点击校验" }}</van-button>
        <div class="order-first-div" style="background-color: white">
          <div style="color: orangered;line-height: 26px;margin-left: 10px">
            <span>*校验详情词 (请在主宝贝详情页内容中找到，符合验证的一段话或词)</span>
          </div>
        </div>
      </div>
      <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <div class="order-first-div" style="background-color: white">
        <div style="color: #5995fd;line-height: 44px;margin-left: 10px;">
          <span>第二步：浏览目标商品图</span>
        </div>
      </div>
      <van-list>
        <van-cell>
          <template #title>
            <span>1, 根据商品主图， 价格， 名称等找到目标商品， 点击"进入店铺"按钮</span>
          </template>
        </van-cell>
        <van-cell>
          <template #title>
            <span>1, 进入目标商品详情页， 从头到尾慢慢浏览， 停留至少三分钟。</span>
          </template>
        </van-cell>
      </van-list>
      <div v-if="isNotDouyinTaskType && !taskCommon.verifyTaoLinke">
      <div class="order-first-div" style="background-color: white" >
        <div style="color: orangered;line-height: 26px;margin-left: 10px">
          <span>检验宝贝链接</span>
        </div>
      </div>
      <van-field type="textarea" v-model="goodsLink" placeholder="宝贝链接或者淘口令" :border="true"/>
      <van-button type="info" size="normal" @click="checkGoodsLink" style="width: 100%;">点击查看商品是否正确</van-button>
      <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <div class="order-first-div" style="background-color: white" v-show="isNotBrowerOrder">
        <div style="color: orangered;line-height: 26px;margin-left: 10px">
          淘口令获取
        </div>
        <div>
          <van-button type="info" size="mini" @click.prevent="show = true">淘口令示例图</van-button>
          <van-dialog v-model="show" title="淘口令示例图" :confirm="closeDialog">
               <img style="height: 640px" src="../../assets/img/taokouling.png" />
          </van-dialog>
        </div>
      </div>
      <van-list>
        <van-cell>
          <template #title>
            <span>1, 找到购买页， 点击标题右侧的【分享】按钮</span>
          </template>
        </van-cell>
        <van-cell>
          <template #title>
            <span>2, 在弹出的界面中选择【复制链接】</span>
          </template>
        </van-cell>
        <van-cell>
          <template #title>
            <span>3, 回填到app宝贝核对链接页面</span>
          </template>
        </van-cell>
      </van-list>
      <div class="order-first-div" style="background-color: white">
        <div style="color: orangered;line-height: 26px;margin-left: 10px">
        </div>
        <div style="color: #0066FF;line-height: 26px;margin-left: 10px">
          <a href="">
            <van-icon name="warning-o"/>
            如淘口令核验无法完成， 可以使用[宝贝链接核验],点我看教程</a>
        </div>
      </div>
      </div>
      <div style="width: 100%;" v-if="isshowQuanLink">
        <div class="order-first-div" style="background-color: white">
          <div style="color: orangered;line-height: 26px;margin-left: 10px">
            <span><van-icon name="browsing-history-o"/>需要领券下单， 领券链接：</span>
          </div>
          <div>
            <van-button type="info" size="mini"
                        v-clipboard:copy="taskCommon.goodsQuanUrl"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError">点击复制
            </van-button>
          </div>
        </div>
        <van-field type="textarea" v-model="taskCommon.goodsQuanUrl" placeholder="优惠券链接" :border="true"
                   disabled/>
      </div>
      <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <div class="order-first-div" style="background-color: gray">
        <div style="margin: 10px;">
          <van-icon name="star"/>
          <span>操作要求</span>
        </div>
      </div>
      <div v-show="isNotBrowerOrder">
      <div class="order-first-div" style="background-color: white">
        <div style="color: #5995fd;line-height: 44px;margin-left: 10px;">
          <span>第三步：下单支付</span>
        </div>
      </div>
      <van-list>
        <van-cell>
          <template #title>
            <span>1, 拍下数量：<span style="color: red">{{ getOrderNums }}</span></span>
          </template>
        </van-cell>
        <van-cell>
          <template #title>
            <span>2, 把商品加入购物车， 确认件数， 颜色尺码和留言要求，下单付款</span>
          </template>
          <template #label>
            <van-row :gutter="2" v-for="(oItem, oindex) in cardData.taskOrderDetailGoodsVos" :key="oindex">
              <van-col :span="12">
                <span style="overflow: hidden;width: 100%;white-space: break-word;text-overflow: ellipsis;">
                <span>{{oItem.isMainGood?"主":"副"}}</span>宝贝规格:<span style="color: red;">{{oItem.goodRule}}</span>
                </span>
              </van-col>
              <van-col :span="6">金额:<span style="color: red">{{oItem.buyPrice}}</span></van-col>
              <van-col :span="6">数量:<span style="color: red">{{oItem.buyNumbers}}</span></van-col>
            </van-row>
          </template>
        </van-cell>
        <van-cell>
          <template #title>
            <span>3, 实际付款总金额：
              <span style="color: red"> {{ cardData.money }}
                <span v-if="cardData.expressMoney != null&&cardData.expressMoney>0">( 注：包含垫付物流费 {{ cardData.expressMoney}} 元)</span>
              </span>
            </span>
          </template>
        </van-cell>
        <van-cell>
          <template #title>
            <span>4, 付款完成后， 进入<span style="color: red">订单详情</span>， 付款详情页截图</span>
          </template>
        </van-cell>
        <van-cell>
          <template #title>
            <span>5, 订单留言 拍下商品所需要填写的买家留言:<span style="color: red"> {{cardData.orderContent}}</span></span>
          </template>
        </van-cell>
      </van-list>
      </div>

      <div style="background-color: white" v-if="taskCommon.taskLimits.includes('核验码')">
        <div style="width:100%;color: orangered;line-height: 26px;margin-left:10px;">
          <span><van-icon name="browsing-history-o"/>需要上传核验码：</span>
        </div>
        <van-row :gutter="0" style="width:100%;margin: 2%;padding-top: 2%;background-color: white">
          <van-col :span="24">
            <van-field name="verifyCodeUrl">
              <template #input>
                <van-uploader accept="image/*" :max-count="1" v-model="imageVerifyCodeFile"
                              :after-read="afterVerifyCodeImages" style="text-align: center; margin: 0 auto;">
                </van-uploader>
              </template>
            </van-field>
          </van-col>
        </van-row>
      </div>

      <!--start 处理需要截图上传的逻辑-->
      <div v-show="isShowNeedImage" style="margin-top: 5%;">
        <!-- 1,添加购物车截图-->
        <div v-show="isShowSingImage('addCardReview')">
        <div class="order-first-div" style="background-color: white">
          <div style="color: orangered;line-height: 26px;margin-left: 10px">
            <span><van-icon name="browsing-history-o"/>添加购物车截图</span>
          </div>
        </div>
        <van-row :gutter="0" style="background-color: white" type="flex" justify="center">
          <div style="margin: 2%;padding-top: 2%;">
            <van-col :span="24">
              <van-field name="IdCardBUrl">
                <template #input>
                  <van-uploader accept="image/*" reupload :max-count="1" v-model="addCardReviewImageFile" :after-read="afterAddCardImages">
                  </van-uploader>
                </template>
              </van-field>
            </van-col>
          </div>
        </van-row>
        </div>

        <!-- 2,浏览副宝贝-->
        <div v-show="isShowSingImage('browserGoodReview')">
          <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
        <div class="order-first-div" style="background-color: white" >
          <div style="color: orangered;line-height: 26px;margin-left: 10px">
            <span><van-icon name="browsing-history-o"/>浏览副宝贝截图</span>
          </div>
        </div>
        <van-row :gutter="0" style="background-color: white" type="flex" justify="center">
          <div style="margin: 2%;padding-top: 2%;">
            <van-col :span="24">
              <van-field name="IdCardBUrl">
                <template #input>
                  <van-uploader accept="image/*" reupload :max-count="1" v-model="browserGoodReviewImageFile" :after-read="afterBrowserGoodImages">
                  </van-uploader>
                </template>
              </van-field>
            </van-col>
          </div>
        </van-row>
        </div>

        <!-- 3,浏览目标宝贝-->
        <div v-show="isShowSingImage('browserTargetGoodReview')">
          <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
        <div class="order-first-div" style="background-color: white">
          <div style="color: orangered;line-height: 26px;margin-left: 10px">
            <span><van-icon name="browsing-history-o"/>搜索关键词截图（可以看到主宝贝）</span>
          </div>
        </div>
        <van-row :gutter="0" style="background-color: white" type="flex" justify="center">
          <div style="margin: 2%;padding-top: 2%;">
            <van-col :span="24">
              <van-field name="IdCardBUrl">
                <template #input>
                  <van-uploader accept="image/*" reupload :max-count="1" v-model="browserTargetGoodReviewImageFile" :after-read="afterBrowserTargetGoodImages">
                  </van-uploader>
                </template>
              </van-field>
            </van-col>
          </div>
        </van-row>
        </div>

        <!-- 4,需要假聊-->
        <div v-show="isShowSingImage('needToTalkReview')">
          <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
        <div class="order-first-div" style="background-color: white" >
          <div style="color: orangered;line-height: 26px;margin-left: 10px">
            <span><van-icon name="browsing-history-o"/>需要假聊截图</span>
          </div>
        </div>
        <van-row :gutter="0" style="background-color: white" type="flex" justify="center">
          <div style="margin: 2%;padding-top: 2%;">
            <van-col :span="24">
              <van-field name="IdCardBUrl">
                <template #input>
                  <van-uploader accept="image/*" reupload :max-count="1" v-model="needToTalkReviewImageFile" :after-read="afterNeedToTalkImages">
                  </van-uploader>
                </template>
              </van-field>
            </van-col>
          </div>
        </van-row>
        </div>

        <!-- 5,收藏店铺-->
        <div v-show="isShowSingImage('collectShopReview')">
          <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
        <div class="order-first-div" style="background-color: white">
          <div style="color: orangered;line-height: 26px;margin-left: 10px">
            <span><van-icon name="browsing-history-o"/>收藏店铺截图</span>
          </div>
        </div>
        <van-row :gutter="0" style="background-color: white" type="flex" justify="center">
          <div style="margin: 2%;padding-top: 2%;">
            <van-col :span="24">
              <van-field name="IdCardBUrl">
                <template #input>
                  <van-uploader accept="image/*" reupload :max-count="1" v-model="collectShopReviewImageFile" :after-read="afterCollectShopImages">
                  </van-uploader>
                </template>
              </van-field>
            </van-col>
          </div>
        </van-row>
        </div>

        <!-- 6,收藏宝贝-->
        <div v-show="isShowSingImage('collectGoodReview')">
          <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
        <div class="order-first-div" style="background-color: white">
          <div style="color: orangered;line-height: 26px;margin-left: 10px">
            <span><van-icon name="browsing-history-o"/>收藏宝贝截图</span>
          </div>
        </div>
        <van-row :gutter="0" style="background-color: white" type="flex" justify="center">
          <div style="margin: 2%;padding-top: 2%;">
            <van-col :span="24">
              <van-field name="IdCardBUrl">
                <template #input>
                  <van-uploader accept="image/*" reupload :max-count="1" v-model="collectGoodReviewImageFile" :after-read="afterCollectGoodImages">
                  </van-uploader>
                </template>
              </van-field>
            </van-col>
          </div>
        </van-row>
        </div>

        <!-- 7,货比足迹-->
        <div v-show="isShowSingImage('compareGoodReview')">
          <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
          <div class="order-first-div" style="background-color: white">
            <div style="color: orangered;line-height: 26px;margin-left: 10px">
              <span><van-icon name="browsing-history-o"/>货比足迹截图</span>
            </div>
          </div>
          <van-row :gutter="0" style="background-color: white" type="flex" justify="center">
            <div style="margin: 2%;padding-top: 2%;">
              <van-col :span="24">
                <van-field name="IdCardBUrl">
                  <template #input>
                    <van-uploader accept="image/*" reupload :max-count="1" v-model="compareGoodReviewImageFile" :after-read="afterCompareGoodImages">
                    </van-uploader>
                  </template>
                </van-field>
              </van-col>
            </div>
          </van-row>
        </div>
      </div>
      <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <!-- end -->


      <div v-show="isNotBrowerOrder">
      <div class="order-first-div" style="background-color: white">
        <div style="color: orangered;line-height: 26px;margin-left: 10px">
          <span v-if="taskCommon.baseMoneyReturnType"><van-icon name="browsing-history-o"/>付款二维码截图</span>
          <span v-else><van-icon name="browsing-history-o"/>支付截图</span>
        </div>
      </div>
      <van-row :gutter="0" style="background-color: white">
        <div style="margin: 2%;padding-top: 2%;">
          <van-col :span="11">
            <van-field name="IdCardBUrl">
              <template #input>
                <van-uploader accept="image/*" reupload :max-count="1" v-model="payImageFile" :after-read="afterImages">
                </van-uploader>
              </template>
            </van-field>
          </van-col>
          <van-col :span="2">
            <div
                style="padding: 16px 6px 1px;margin-left: 12px;border-left: 1px solid;font-size: 0;height: 210px;"></div>
          </van-col>
          <van-col :span="11">
            <van-image
                @click="perviewImage(imageDyUrl)"
                :src="imageDyUrl"></van-image>
          </van-col>
        </div>
      </van-row>

      <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <div class="order-first-div" style="background-color: white">
        <div style="color: #5995fd;line-height: 44px;margin-left: 10px;">
          <span>第四步：填写实付金额</span>
        </div>
      </div>
      <van-list>
        <van-cell>
          <template #title>
            <span >1, 应垫付金额参考：<span style="color: red"> {{ cardData.money }}</span></span>
          </template>
        </van-cell>
        <van-cell>
          <template #title>
            <span style="color: red;">2, 若实际支付金额低于商家垫付金额， 请务必按照实际支付金额填写， 否则商家申诉会封号处理</span>
          </template>
        </van-cell>
        <van-cell>
          <template #title>
            <span style="color: red;">3, 平台规定超过商家设置金额<span>{{taskCommon.anomalyMoneyLimit}}</span>以上无法提交，金额差价过大请联系平台客服处理。</span>
          </template>
        </van-cell>
        <van-cell>
          <template #title>
            <span style="color: red;">4, 若实际付款金额高于商家垫付金额， 请务必按照实际支付金额填写，任务正常进行，商家在24小时内会审核补差价</span>
          </template>
        </van-cell>
      </van-list>
      <div class="order-first-div" style="background-color: white">
        <div style="color: red;line-height: 26px;margin-left: 10px">
          <span>填写订单实付金额</span>
        </div>
      </div>
      <van-field required type="textarea" v-model="b2cOperationTaskResult.realyPayMoney" placeholder="输入实付金额" :border="true"/>
      <div class="order-first-div" style="background-color: white">
        <div style="color: #5995fd;line-height: 44px;margin-left: 10px;">
          <span>第五步：填写订单号</span>
        </div>
      </div>
      <div class="order-first-div" style="background-color: white">
        <div style="color: red;line-height: 26px;margin-left: 10px">
          <span>填写平台订单编号</span>
        </div>
      </div>
      <van-field required type="textarea" v-model="b2cOperationTaskResult.plateformNumber" placeholder="输入平台订单编号" :border="true"/>
      </div>
      <van-button type="info" size="normal" @click="commitTaskOperInfo">提交任务信息</van-button>
    </div>
    <van-dialog v-model="isShowDialog" :before-close="beforClose">
      <div style="margin: 5%;">
      <span>校验成果， 请浏览宝贝详情，系统将在倒计时
        <span style="color: red">{{ shopTimeLimit }}</span>
        秒后显示任务下单要求。
      </span>
      </div>
    </van-dialog>

    <!--新增商返的提示-->
    <div v-show="taskCommon.baseMoneyReturnType" style="position: fixed; right: 2%; bottom: calc(20% + env(safe-area-inset-bottom, 0px));">
      <van-tag type="primary" size="large">商家返款</van-tag>
    </div>
  </div>
</template>

<script>
import HourSecondCount from "../../components/HourSecondCount";
import {
  cancelOrder,
  checkGoodsLink,
  checkShopName,
  commitOrderOperInfo,
  getTaskCommont
} from "../../api/system/mobile_taskorder";
import {getTokenUser, isEmptyObject, isStrEmpty} from "../../lib/utils";
import {Dialog, ImagePreview, Toast} from "vant";
import {MessageBox} from "mint-ui";
import {getOrderOpreationTime, getSysOrderSetting, uploaderToServer} from "../../api/system/sys_backInfo";
import Expand from "../../lib/expand";

export default {
  name: "OperationTask",
  components: {
    HourSecondCount
  },
  data() {
    return {
      show: false,
      isShowDialog: false,
      goodsLink: "",
      shopName: "",
      plateformordertype: "请注意核对店铺名",
      iconUrl: "cart-circle-o",
      orderStatus: "待操作-核对店名",
      shopTimeLimit: 60,
      cardData: {
      },
      orderTimeLimit: {},
      taskCommon: {
        qrcodeTaskImgUrl: null
      },
      answerString: "",
      isCheckAnswer: false,
      accountName: "",
      payImageFile: [],
      imageVerifyCodeFile: [],
      /*处理需要上传截图的商家附加服务*/
      addCardReviewImageFile:[],
      browserGoodReviewImageFile:[],
      browserTargetGoodReviewImageFile:[],
      needToTalkReviewImageFile:[],
      collectShopReviewImageFile:[],
      collectGoodReviewImageFile:[],
      compareGoodReviewImageFile:[],
      /*end*/
      b2cOperationTaskResult: {
        orderOperImages:[]
      },
      list: [
        {
          orderKey: "买号",
          orderVal: "Love2106868"
        },
      ],
      loading: false,
      finished: false,
      imageDyUrl: "https://myb2c.oss-cn-hangzhou.aliyuncs.com/admin/image0.jpg",
      //fix bug 新增浏览器转入后台后的时间点
      hiddenTime: null
    }
  },
  //fix bug浏览器转入后台时计时出错
  created() {
    document.addEventListener("visibilitychange", this.confirmShopTimesCallback)

    //处理苹果系统的兼容
    document.addEventListener("pagehide", this.iosConfirmShopTimesCallback)
  },
  mounted() {
    this.$emit("titleChange", "操作任务");
    this.cardData = this.$route.query;
    sessionStorage.setItem("b2cOrderUserId", this.cardData.b2cOrderOperationInfos[0].b2cOrderUserId);
    console.log(this.cardData);
    getTaskCommont(this.cardData).then(res => {
      console.log(res.data)
      if (res.success) {
        this.taskCommon = res.data;
        //新增判断店铺是否已经验证通过
        if (this.taskCommon.verifyShopReady){
          this.b2cOperationTaskResult.isShopVerfiy = true;
          if (this.taskCommon.commitOrderTimeLimit > 0){
            this.shopTimeLimit = this.taskCommon.commitOrderTimeLimit
            this.countShopTimeLimit();
            this.isShowDialog = true
          }
        }
        getOrderOpreationTime({orderNumber:res.data.orderNum, b2cTaskTypeId:this.$route.query.b2cTaskTypeId}).then(res => {
          if (res.success) {
            //console.log("11111", res.data)
            this.orderTimeLimit = res.data;
          }
        }).catch(err => {
          MessageBox({
            title: '提示',
            message: err.message,
            showCancelButton: true
          });
          if (err.code == 508){
            this.$router.replace({path:'/home/usertaskmgelist'});
          }
        });
      }
    }).catch(err => {
      MessageBox({
        title: '提示',
        message: err.message,
        showCancelButton: true
      });
    });

    this.accountName = getTokenUser();

  },
  computed: {
    //新增判断是否浏览单
    isNotBrowerOrder(){
      if (!isStrEmpty(this.taskCommon.taskType)){
        return this.taskCommon.taskType != "手淘浏览单"
      }
    },
    isNotDouyinTaskType(){
      return this.taskCommon.taskType != "抖音小店"
    },
    //隔天单
    isAfterDayOrder(){
      return this.taskCommon.taskType == "手淘隔天任务"
    },
    isShowBusinesses(){
      return !isStrEmpty(this.taskCommon.remarksContent)
          || !isStrEmpty(this.taskCommon.firstImageUrl)
          || !isStrEmpty(this.taskCommon.secondImageUrl)
          || !isStrEmpty(this.taskCommon.thirdImageUrl);
    },
    isShowBusinessAttarch(){
      return function (str) {
        return !isStrEmpty(str);
      }
    },
    isshowQuanLink(){
      return !isStrEmpty(this.taskCommon.goodsQuanUrl);
    },
    isShowQuesting(){
      return !isStrEmpty(this.taskCommon.questionString);
    },
    getQuestiongStr(){
      let str = this.taskCommon.questionString;
      let tmpStr = "";
      for (let i=0; i<str.length; i++){
        if (i!=0&&i%2!=0){
          tmpStr=tmpStr.concat("*")
        }else{
          tmpStr=tmpStr.concat(str.charAt(i))
        }
      }
      //return str.substr(0, 1)+"*"+str.substr(2, 3)+"*"+str.substr(2, str.length-2)+"*";
      return tmpStr;
    },
    getOrderNums(){
      return this.cardData.taskOrderDetailGoodsVos.reduce((p, item) => {
        return p+item.buyNumbers;
      }, 0)
    },
    getOrderTotalMoney(){
      return this.cardData.taskOrderDetailGoodsVos.reduce((p, item) => {
        return p + item.buyNumbers*item.buyPrice;
      }, 0)
    },
    getTime() {
      return this.$store.getters.getOrderTimeLimit.opTimeLimit;
    },
    isShowQrcodeImg(){
      return !isStrEmpty(this.taskCommon.qrcodeTaskImgUrl);
    },
    isShowNeedImage(){
      return !isEmptyObject(this.taskCommon.taskSerNeedUpimgs);
    },
    isShowSingImage(){
      return function (val) {
        return this.taskCommon.taskSerNeedUpimgs!=null&&this.taskCommon.taskSerNeedUpimgs.hasOwnProperty(val)&&this.taskCommon.taskSerNeedUpimgs[val];
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener("visibilitychange", this.confirmShopTimesCallback)
    document.removeEventListener("pagehide", this.iosConfirmShopTimesCallback)
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    //fix bug
    confirmShopTimesCallback(){
      if (document.hidden){
        this.hiddenTime = Date.now();
      }else{
        this.shopTimeLimit =
            this.shopTimeLimit - ((Date.now() - this.hiddenTime) / 1000).toFixed(0)
        if (this.shopTimeLimit > 0){
          this.countShopTimeLimit();
        }else{
          this.shopTimeLimit = 0
        }
      }
    },
    //fix ios bug
    iosConfirmShopTimesCallback(e){
      if (e.persisted){
        this.hiddenTime = Date.now();
      }else{
        this.shopTimeLimit =
            this.shopTimeLimit - ((Date.now() - this.hiddenTime) / 1000).toFixed(0)
        if (this.shopTimeLimit > 0){
          this.countShopTimeLimit();
        }else{
          this.shopTimeLimit = 0
        }
      }
    },
    closeDialog() {
      this.show = false;
    },
    filterKeys(lists) {
      return lists.filter(item => item!=null&&!item.includes("限制") && !item.includes("商家自主审核"));
    },
    onCopy(e) {
      alert('复制成功！: ' + e.text)
    },
    onError(e) {
      alert('你的浏览器不支持复制拷贝！')
    },
    perviewImage(imgUrl) {
      ImagePreview({
        images: [
          imgUrl
        ],
        closeable: true,
      });
    },
    onLoad() {
      if (this.list != null) {
        // 加载状态结束
        this.loading = false;
        this.finished = true;
      }
    },
    countDowmEnd() {
      cancelOrder(this.$route.query).then(res => {
        if (res.success) {
          this.$router.back();
        }
      }).catch(err => {
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        });
      });
    },
    countShopTimeLimit() {
      var self = this;
      clearInterval(this.timer)
      this.timer = setInterval(function () {
        if (self.shopTimeLimit > 0) {
          self.shopTimeLimit = self.shopTimeLimit - 1;
        }
      }, 1000);
    },
    beforClose(action, done) {
      if (action == "confirm") {
        if (this.shopTimeLimit > 0) {
          done(false)
        } else {
          done(true)
        }
      }
    },
    checkAnswer() {
      this.isCheckAnswer = this.answerString == this.taskCommon.answerString ? true : false;
      if (!this.isCheckAnswer) {
        Dialog.alert({message: "校验未通过"})
      }
    },
    checkShopName() {
      //console.log(this.shopName)
      let taskCommonTmp = Object.assign({}, this.taskCommon);
      taskCommonTmp.shopName = this.shopName;
      checkShopName(taskCommonTmp).then(res => {
        if (res.success) {
          this.isShowDialog = true;
          this.b2cOperationTaskResult.isShopVerfiy = true;
          getSysOrderSetting().then(res => {
            if (res.success) {
              this.shopTimeLimit = res.data.commitOrderTimeLimit * 60;
              this.countShopTimeLimit();
            }
          });
          /*
          Dialog.alert({message:'', beforeClose:(action, done) => {
              if (action == 'confirm'){
                console.log(action)
                done(true);
              }
          } }).then(() =>{
            this.b2cOperationTaskResult.isShopVerfiy = true;
            console.log(this.b2cOperationTaskResult);
          });
           */
        }
      }).catch(err => {
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        });
      });
    },
    checkGoodsLink() {
      this.taskCommon.goodsUrl = this.goodsLink;
      checkGoodsLink(this.taskCommon).then(res => {
        if (res.success) {
          Toast.success("校验成果");
          this.b2cOperationTaskResult.isGoodLinkVerfiy = true;
        }
      }).catch(err => {
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        });
      });
    },
    afterVerifyCodeImages(file) {
      let tempFile = file.file;
      let type = tempFile.type;
      let size = tempFile.size;
      let newName = new Date().getTime() + tempFile.name;
      let uploadFile = new File([tempFile], newName, {type, size});
      let formData = new FormData();

      file.status = 'uploading';
      file.message = "上传中....";

      formData.append('file', uploadFile);
      uploaderToServer(formData).then(res => {
        if (res.success) {
          file.status = 'success';
          file.message = '上传成功';
          this.b2cOperationTaskResult.orderVerifyCodeImage = res.data;
        }
      });
    },
    afterImages(file) {
      let tempFile = file.file;
      let type = tempFile.type;
      let size = tempFile.size;
      let newName = new Date().getTime() + tempFile.name;
      let uploadFile = new File([tempFile], newName, {type, size});
      let formData = new FormData();

      file.status = 'uploading';
      file.message = "上传中....";

      formData.append('file', uploadFile);
      uploaderToServer(formData).then(res => {
        if (res.success) {
          file.status = 'success';
          file.message = '上传成功';
          this.b2cOperationTaskResult.orderOperImages.push(res.data);
        }
      });
    },
    /*处理需要上传截图的商家附加服务*/
    afterAddCardImages(file) {
      let tempFile = file.file;
      let type = tempFile.type;
      let size = tempFile.size;
      let newName = new Date().getTime() + tempFile.name;
      let uploadFile = new File([tempFile], newName, {type, size});
      let formData = new FormData();

      file.status = 'uploading';
      file.message = "上传中....";

      formData.append('file', uploadFile);
      uploaderToServer(formData).then(res => {
        if (res.success) {
          file.status = 'success';
          file.message = '上传成功';
          this.b2cOperationTaskResult.orderOperImages.push(res.data);
        }
      });
    },
    afterBrowserGoodImages(file) {
      let tempFile = file.file;
      let type = tempFile.type;
      let size = tempFile.size;
      let newName = new Date().getTime() + tempFile.name;
      let uploadFile = new File([tempFile], newName, {type, size});
      let formData = new FormData();

      file.status = 'uploading';
      file.message = "上传中....";

      formData.append('file', uploadFile);
      uploaderToServer(formData).then(res => {
        if (res.success) {
          file.status = 'success';
          file.message = '上传成功';
          this.b2cOperationTaskResult.orderOperImages.push(res.data);
        }
      });
    },
    afterBrowserTargetGoodImages(file) {
      let tempFile = file.file;
      let type = tempFile.type;
      let size = tempFile.size;
      let newName = new Date().getTime() + tempFile.name;
      let uploadFile = new File([tempFile], newName, {type, size});
      let formData = new FormData();

      file.status = 'uploading';
      file.message = "上传中....";

      formData.append('file', uploadFile);
      uploaderToServer(formData).then(res => {
        if (res.success) {
          file.status = 'success';
          file.message = '上传成功';
          this.b2cOperationTaskResult.orderOperImages.push(res.data);
        }
      });
    },
    afterNeedToTalkImages(file) {
      let tempFile = file.file;
      let type = tempFile.type;
      let size = tempFile.size;
      let newName = new Date().getTime() + tempFile.name;
      let uploadFile = new File([tempFile], newName, {type, size});
      let formData = new FormData();

      file.status = 'uploading';
      file.message = "上传中....";

      formData.append('file', uploadFile);
      uploaderToServer(formData).then(res => {
        if (res.success) {
          file.status = 'success';
          file.message = '上传成功';
          this.b2cOperationTaskResult.orderOperImages.push(res.data);
        }
      });
    },
    afterCollectShopImages(file) {
      let tempFile = file.file;
      let type = tempFile.type;
      let size = tempFile.size;
      let newName = new Date().getTime() + tempFile.name;
      let uploadFile = new File([tempFile], newName, {type, size});
      let formData = new FormData();

      file.status = 'uploading';
      file.message = "上传中....";

      formData.append('file', uploadFile);
      uploaderToServer(formData).then(res => {
        if (res.success) {
          file.status = 'success';
          file.message = '上传成功';
          this.b2cOperationTaskResult.orderOperImages.push(res.data);
        }
      });
    },
    afterCollectGoodImages(file) {
      let tempFile = file.file;
      let type = tempFile.type;
      let size = tempFile.size;
      let newName = new Date().getTime() + tempFile.name;
      let uploadFile = new File([tempFile], newName, {type, size});
      let formData = new FormData();

      file.status = 'uploading';
      file.message = "上传中....";

      formData.append('file', uploadFile);
      uploaderToServer(formData).then(res => {
        if (res.success) {
          file.status = 'success';
          file.message = '上传成功';
          this.b2cOperationTaskResult.orderOperImages.push(res.data);
        }
      });
    },
    afterCompareGoodImages(file) {
      let tempFile = file.file;
      let type = tempFile.type;
      let size = tempFile.size;
      let newName = new Date().getTime() + tempFile.name;
      let uploadFile = new File([tempFile], newName, {type, size});
      let formData = new FormData();

      file.status = 'uploading';
      file.message = "上传中....";

      formData.append('file', uploadFile);
      uploaderToServer(formData).then(res => {
        if (res.success) {
          file.status = 'success';
          file.message = '上传成功';
          this.b2cOperationTaskResult.orderOperImages.push(res.data);
        }
      });
    },
    /*end结束*/
    //判断要上传的图片是否全部上传
    verifyUploadImages() {
      let needUpImages = 0;
      for (let key in this.taskCommon.taskSerNeedUpimgs) {
        if (this.taskCommon.taskSerNeedUpimgs[key]) {
          needUpImages = needUpImages + 1;
        }
      }
      if (!isEmptyObject(this.taskCommon.taskSerNeedUpimgs) && needUpImages > 0) {
        let imgSize = this.b2cOperationTaskResult.orderOperImages.length;
        if (!isStrEmpty(this.b2cOperationTaskResult.orderVerifyCodeImage)) {
          imgSize = imgSize + 1;
        }
        if (this.isNotBrowerOrder){
          if (imgSize >= needUpImages + 1) {
            return true;
          } else {
            return false;
          }
        }else{
          if (imgSize >= needUpImages) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return true;
      }
    },
    //end
    checkTaoOrderNum(orderNum){
      //判断是什么平台的订单
      console.log(this.taskCommon.taskType);
       if (this.taskCommon.taskType.indexOf("京东")!=-1
         || this.taskCommon.taskType.indexOf("京喜") != -1){
        let regx = new RegExp("^[0-9]{12}$");
        if (!regx.test(orderNum)){
          return false;
        }else{
          return true;
        }
      }else if (this.taskCommon.taskType.indexOf("拼多多")!=-1){
        let regx = new RegExp("^[0-9]{6}-[0-9]{15}$");
        if (!regx.test(orderNum)){
          return false;
        }else{
          return true;
        }
      }else if(this.taskCommon.taskType.indexOf("阿里巴巴")!=-1){
         let regx = new RegExp("^[0-9]{18}$|^[0-9]{19}$");
         console.log(orderNum)
         if (!regx.test(orderNum)){
           return false;
         }else{
           return true;
         }
       }else{
         let regx = new RegExp("^[0-9]{19}$");
         if (!regx.test(orderNum)){
           return false;
         }else{
           return true;
         }
      }
    },
    commitTaskOperInfo() {
      if (this.isNotBrowerOrder
          && (isStrEmpty(this.b2cOperationTaskResult.realyPayMoney)
          || isStrEmpty(this.b2cOperationTaskResult.plateformNumber))) {
        MessageBox({
          title: '提示',
          message: "实际支付金额和平台订单号为必填字段！",
          showCancelButton: true
        });
      } else {
        if (this.isNotBrowerOrder && !this.checkTaoOrderNum(this.b2cOperationTaskResult.plateformNumber)){
          MessageBox({
            title: '提示',
            message: "订单号输入不合法，请输入合法的平台订单号！",
            showCancelButton: true
          });
        }else if (!this.b2cOperationTaskResult.isShopVerfiy) {
          MessageBox({
            title: '提示',
            message: "请确认验证店铺通过！",
            showCancelButton: true
          });
        } else if (!this.verifyUploadImages()) {
          MessageBox({
            title: '提示',
            message: "请确认图片上传完成通过！",
            showCancelButton: true
          });
        } else if (this.isNotDouyinTaskType && !this.b2cOperationTaskResult.isGoodLinkVerfiy) {
          MessageBox({
            title: '提示',
            message: "请确认淘口令或者主宝贝链接验证通过！",
            showCancelButton: true
          });
        } else if (!isStrEmpty(this.taskCommon.questionString)
            && (!this.isCheckAnswer || isStrEmpty(this.taskCommon.answerString))) {
          MessageBox({
            title: '提示',
            message: "请确认问答验证通过！",
            showCancelButton: true
          });
        } else {
          this.b2cOperationTaskResult.b2cOrderUserId = sessionStorage.getItem("b2cOrderUserId");
          commitOrderOperInfo(this.b2cOperationTaskResult).then(res => {
            if (res.success) {
              this.$router.push({path: '/home/usertaskmgelist'});
            }
          }).catch(err => {
            MessageBox({
              title: '提示',
              message: err.message,
              showCancelButton: true
            });
          });
        }
      }
    },
    //保存网络的图片到手机相册
    savePicture(Url){
      if(window.plus){
        plusReady();
      }else{
        document.addEventListener('plusready', plusReady, false);
      }

      async function plusReady(){
        console.log("已经加载plusReady");
        try {
          await new Expand().saveImgToLocal({path: Url});
          Toast.success("下载成功！");
        }catch (e) {
          Toast.fail("下载失败！");
          console.log(JSON.stringify(e))
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .van-uploader__upload {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  box-sizing: border-box;
  width: 156px;
  height: 230px;
  margin: 0 8px 8px 0;
  background-color: #f7f8fa;
}

::v-deep .van-uploader__wrapper{
  width: 156px;
  height: 230px;
}

::v-deep .van-uploader__preview{
  width: 156px;
  height: 230px;
}

::v-deep .van-uploader__preview-image{
  display: block;
  width: 156px;
  height: 230px;
  overflow: hidden;
}

::v-deep .van-uploader__preview-delete{
  width: 32px;
  height: 32px;
}

::v-deep .van-uploader__preview-delete-icon{
  position: absolute;
  top: 6px;
  right: 12px;
  --webkit-transform: scale(1.2);
  transform: scale(1.2);
}

.order-main {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  margin-left: 1%;
  width: 98%;

  .order-first-div {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    background-color: #FF6699;
    font-size: small;
    color: white;
  }

  .end-box {
    font-size: small;
  }
}
</style>
